import pick from 'lodash/pick';
import groupBy from 'lodash/groupBy';
import { types } from './types';
import { isNil } from 'lodash';
import {
  documentKeys,
  carrierKeys,
  expensesKeys,
  termsKeys,
  xedmKeys,
} from 'store/utils';
import { setActiveFormId } from './actions';
import { mapMainformDetails } from './utils';

const INITIAL_STATE = {
  documents: {},
  carrier: {
    viewMode: false,
    existCon: true,
    contactPersonFlag: true,
    hasShareholdersFlag: false,
    rejectReasons: {
      isSubmitValid: true,
    },
  },
  task: {},
  content: [],
  localeStrings: [],
  loadingLocales: false,
  appConfig: {
    initiated: false,
    hasError: false,
    hasInfo: false,
    loading: false,
    message: '',
    gsisAuthUrl: true,
    rememberMe: false,
  },
  applicationLoading: false,
  error: {},
  companyDetails: {},
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.SET_FORM_INITIATED:
      return { ...state, initiated: true };

    case types.SET_FORM_INFO:
      return { ...state, hasInfo: true, message: payload };

    case types.UPDATE_USER.SUCCESS:
      return { ...state, ...payload };

    case types.UPLOAD_FILE.SUCCESS:
      return {
        ...state,
      };

    case types.LOAD_SYSTEM_LOCALES.START:
      return {
        ...state,
        loadingLocales: true, // Set loading to true when fetching locales
      };

    case types.LOAD_SYSTEM_LOCALES.SUCCESS: {
      const locales = {}; // Declare locales only once
      if (Array.isArray(payload)) {
        payload.forEach(({ name, localString }) => {
          locales[name] = localString;
        });
      } else {
        console.warn(
          'LOAD_SYSTEM_LOCALES.SUCCESS payload is not an array:',
          payload
        );
      }

      return {
        ...state,
        localeStrings: locales, // Store fetched locales
        loadingLocales: false, // Set loading to false when locales are fetched
      };
    }

    case types.LOAD_SYSTEM_LOCALES.ERROR:
      return {
        ...state,
        loadingLocales: false, // Set loading to false if fetching fails
      };

    case types.LOGIN_START:
      return { ...state, loading: true, hasError: false, message: '' };

    case types.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        hasError: false,
        message: '',
      };

    case types.LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        hasError: true,
        message: payload,
      };

    case types.RESET_USER:
      return {
        ...state,
        initiated: false,
        hasError: false,
        hasInfo: false,
        loading: false,
        message: '',
        gsisAuthUrl: null,
        rememberMe: false,
      };

    case types.UPDATE_FORM_FIELD:
      return {
        ...state,
        [payload.group]: {
          ...state[payload.group],
          [payload.key]: payload.value,
        },
      };
    case types.GET_PROCESS_INSTANCES.SUCCESS:
      const content = groupBy(payload.content, 'field');
      return {
        ...state,
        documents: {
          ...pick(payload.variables, documentKeys(payload.variables)),
          ...content,
        },
        carrier: {
          viewMode: state.carrier.viewMode,
          existCon: state.carrier.existCon,
          contactPersonFlag: state.carrier.contactPersonFlag,
          ...pick(payload.variables, carrierKeys(payload.variables)),
        },
        provider: payload.variables?.provider,
        terms: {
          ...state.terms,
          ...pick(payload.variables, termsKeys(payload.variables)),
        },
        XEDM: {
          ...state.XEDM,
          ...pick(payload.variables, xedmKeys(payload.variables)),
        },
        activeTaskName: payload?.activeTaskName || state.forms?.activeTaskName,
        businessKey: payload.businessKey || state.forms?.businessKey,
        task: {
          ...state.task,
          processInstanceId:
            payload?.processInstanceId || state.forms.task.processInstanceId,
          taskName: payload?.taskName || state.forms.task.taskName,
          taskKey: payload?.taskKey || state.forms.task.taskKey,
        },
      };
    case types.GET_FORM_DATA.SUCCESS:
      const contentItems = groupBy(payload.contentItems, 'field');
      return {
        ...state,
        documents: {
          ...state.documents,
          ...pick(payload.variables, documentKeys(payload.variables)),
          ...contentItems,
        },
        carrier: {
          ...state.carrier,

          viewMode: state.carrier.viewMode,
          ...pick(payload.variables, carrierKeys(payload.variables)),
        },
        terms: {
          ...state.terms,
          ...pick(payload.variables, termsKeys(payload.variables)),
        },
        XEDM: {
          ...state.XEDM,
          ...pick(payload.variables, xedmKeys(payload.variables)),
        },
        formId: payload?.taskKey || state.forms.formId,
        task: {
          ...state.task,
          processInstanceId:
            payload?.processInstanceId || state.forms.task.processInstanceId,
          taskName: payload?.taskName || state.forms.task.taskName,
          taskKey: payload?.taskKey || state.forms.task.taskKey,
        },
      };
    case types.GET_MAINFORM_DETAILS.SUCCESS:
      return mapMainformDetails(payload, state);
    case types.GET_TASK_DATA.SUCCESS:
      return {
        ...state,
        task: {
          ...state.task,
          ...payload,
        },
      };
    case types.GET_TAXIS_DATA_BY_TK.SUCCESS:
      return {
        ...state,
        carrier: {
          ...state.carrier,
          taxis_data_by_tk: payload,
        },
      };
    case types.GET_OTP.SUCCESS:
      return {
        ...state,
        // task: {
        //   ...state.task,
        //   ...payload,
        // },
      };
    case types.CLAIM_ACTIVE.SUCCESS:
      return {
        ...state,
        taskId: payload.taskId || state.forms.taskId,
      };
    case types.CLAIM_ACTIVE_VIEW_MODE.SUCCESS:
      return {
        ...state,
        taskId: payload.taskId || state.forms.taskId,
      };
    case types.GET_FORM_UPLOADS.SUCCESS:
      return {
        ...state,
        content: payload.data,
      };
    case types.GET_PROJECT_PLAN_INFO.SUCCESS:
      return {
        ...state,
        projectPlanInfo: payload,
      };

    case types.CLEAR_FORM.SUCCESS:
      return {
        ...INITIAL_STATE,
        localeStrings: payload === true ? [] : state.localeStrings,
      };

    case types.VALIDATE_OTP.SUCCESS:
      return {
        ...state,
        carrier: {
          ...state.carrier,
          [payload.field + 'Validated']: true,
          otpError: payload.otpError,
        },
      };
    case types.VALIDATE_OTP.ERROR:
      return {
        ...state,
        carrier: {
          ...state.carrier,
          [payload.field + 'Validated']: false,
          otpError: payload.otpError,
        },
      };
    case types.APPROVE_AUDIT.START:
      return {
        ...state,
        submitting: true,
      };
    case types.APPROVE_AUDIT.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.REJECT_AUDIT.START:
      return {
        ...state,
        submitting: true,
      };
    case types.REJECT_AUDIT.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.APPROVE_OBJECTION.START:
      return {
        ...state,
        submitting: true,
      };
    case types.APPROVE_OBJECTION.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.REJECT_OBJECTION.START:
      return {
        ...state,
        submitting: true,
      };
    case types.REJECT_OBJECTION.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.REJECT_TASK.START:
      return {
        ...state,
        submitting: true,
      };
    case types.REJECT_TASK.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.SUBMIT_TASK.START:
      return {
        ...state,
        submitting: true,
      };
    case types.SUBMIT_TASK.SUCCESS:
      return {
        ...state,
        submitting: false,
      };
    case types.SUBMIT_TASK.ERROR:
      return {
        ...state,
        submitting: false,
      };
    case types.UPDATE_FORM_VALIDITY:
      return {
        ...state,
        formValidity: {
          ...state.formValidity,
          [payload.group]: payload.value,
        },
      };
    case types.SUBMIT_CONSENT.SUCCESS:
      return {
        ...state,
        consent: payload.consent,
      };
    case types.TRIGGER_LOADING:
      return {
        ...state,
        applicationLoading: payload,
      };
    case types.REGISTER_USER_DATA.ERROR:
      return {
        ...state,
        error: { ...payload },
        loading: false,
      };
    case types.START_NEW.SUCCESS:
      return mapMainformDetails(payload, state);
    default:
      return state;
  }
};

export default reducer;
